import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      title: 'Custom Suits',
      description: 'Bespoke suits crafted with 30+ precise measurements, 5000+ fabrics available for suits, and custom lining options.',
      features: [
        '30+ Custom Measurements',
        '5000+ Fabrics Available',
        'Custom Lining and Pockets',
        'Bespoke Tailors (100% Custom Made)',
      ],
      image: 'https://public.readdy.ai/ai/img_res/6c8c61ab578640a8ec61aca4e7d8957a.jpg',
      link: '/custom-suits',
    },
    {
      title: 'Custom Dress Shirts',
      description: 'Perfectly fitted dress shirts with 20 collar options, customizable cuffs, sleeves, and premium fabrics.',
      features: [
        '20 Different Collar Options',
        'Customize Cuffs and Sleeves',
        'Premium Fabric Choices',
        'Bespoke Tailors (100% Custom Made)',
      ],
      image: 'https://readdy.ai/api/search-image?query=crisp%20light%20blue%20custom%20dress%20shirt%20with%20white%20collar%20and%20french%20cuffs%20on%20display%20showing%20fine%20cotton%20fabric%20texture%20and%20precise%20tailoring%20details%20in%20elegant%20showroom%20with%20soft%20natural%20lighting&width=600&height=800&seq=service-shirts-002&orientation=portrait',
      link: '/custom-shirts',
    },
    {
      title: 'Custom Blazers',
      description: 'Tailored blazers designed to your exact specifications with premium fabrics and expert craftsmanship.',
      features: [
        'Customized to Exact Fit',
        'Light, Medium and Heavy Weights',
        'Non-Iron Blends Available',
        'Premium Fabric Selection',
      ],
      image: 'https://readdy.ai/api/search-image?query=sophisticated%20navy%20blue%20blazer%20sport%20coat%20on%20wooden%20hanger%20showing%20fine%20wool%20texture%20notch%20lapel%20and%20horn%20buttons%20in%20luxury%20tailoring%20studio%20with%20warm%20lighting%20and%20clean%20minimal%20background&width=600&height=800&seq=service-blazers-003&orientation=portrait',
      link: '/custom-blazers',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Premium Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the finest custom tailoring with expert craftsmanship and premium fabrics
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold text-white mb-1">{service.title}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-gray-600 mb-6">{service.description}</p>

                {/* Features */}
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-[#C4A962] text-xl mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Link
                  to={service.link}
                  className="block w-full bg-[#C4A962] text-white text-center px-6 py-3 rounded-lg font-semibold hover:bg-[#B39952] transition-colors whitespace-nowrap"
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Service Link */}
        <div className="text-center mt-12">
          <Link
            to="/alterations"
            className="inline-flex items-center text-[#C4A962] font-semibold hover:text-[#B39952] transition-colors"
          >
            View Alterations and Other Services
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;